import { ComponentPropsWithoutRef } from "react";

export const AscendingIcon = ({
  ...props
}: ComponentPropsWithoutRef<"svg">) => {
  return (
    <svg {...props} viewBox="0 0 14 14" fill="none">
      <path d="M4.599 4a.593.593 0 0 1-.424-.176L2.598 2.247 1.022 3.824a.604.604 0 0 1-.848 0 .604.604 0 0 1 0-.849l2-2a.604.604 0 0 1 .848 0l2 2a.604.604 0 0 1 0 .849A.593.593 0 0 1 4.6 4Z" />
      <path d="M2.598 13.2a.604.604 0 0 1-.6-.6V1.4c0-.329.272-.6.6-.6.328 0 .6.271.6.6v11.2c0 .329-.272.6-.6.6ZM13.4 11.2H6.999a.604.604 0 0 1-.6-.6c0-.327.272-.6.6-.6h6.4c.329 0 .601.273.601.6 0 .329-.272.6-.6.6ZM10.2 6.4H6.998a.604.604 0 0 1-.6-.6c0-.328.272-.6.6-.6h3.2c.329 0 .6.272.6.6 0 .328-.271.6-.6.6ZM8.6 4H6.998a.604.604 0 0 1-.6-.6c0-.329.272-.6.6-.6h1.6c.328 0 .6.271.6.6 0 .328-.272.6-.6.6ZM11.8 8.8H6.999a.604.604 0 0 1-.6-.6c0-.328.272-.6.6-.6h4.8c.329 0 .6.272.6.6 0 .328-.271.6-.6.6Z" />
    </svg>
  );
};
